import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyOrdersComponent } from './my-orders.component';
import { OpenOrdersComponent } from './open-orders/open-orders.component';
import { BackOrdersComponent } from './back-orders/back-orders.component';
import { ShippedOrdersComponent } from './shipped-orders/shipped-orders.component';
import { SearchOrdersComponent } from './search-orders/search-orders.component';
import { OrderItemDetailComponent } from './order-item-detail/order-item-detail.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { MakePaymentComponent } from '../my-account/make-payment/make-payment.component';
import { PaymentSetupComponent } from '../my-account/payment-setup/payment-setup.component';

const routes: Routes = [
    {
        path: 'myOrder',
        component: MyOrdersComponent,
        data:{
            breadcrumb: 'Orders',
        },
        children: [
            // Maken the Open Order as the default routing
            // {
            //     path: '',
            //     redirectTo: 'openorders',
            //     pathMatch: 'full'
            // },
            {
                path: 'openorders',
                component: OpenOrdersComponent,
                data:{
                    breadcrumb: 'Open Orders',
                },
                children: [
                    {
                        path: 'orderitemdetail/:sku',
                        component: OrderItemDetailComponent,
                        data:{
                            breadcrumb: 'sku',
                        },
                        children: [
                            {
                                path: 'product/:sku',
                                component: ProductDetailComponent,
                                children: [
                                    {
                                        path: 'bundledproduct/:sku',
                                        component: ProductDetailComponent,
                                        data: {
                                            breadcrumb: 'sku',
                                        }
                                    }]
                            },
                            {
                                path: 'payment',
                                component: MakePaymentComponent,
                                data: {
                                  breadcrumb: 'Make a Payment',
                                },
                            },
                            {
                                path: 'digitalwallet',
                                component: PaymentSetupComponent,
                                data: {
                                  breadcrumb: 'Digital Wallet',
                                },
                            },

                        ]
                    },
                    {
                        path: 'payment',
                        component: MakePaymentComponent,
                        data: {
                          breadcrumb: 'Make a Payment',
                        },
                    },
                    // {
                    //     path: 'payment/:response/:reference',
                    //     component: MakePaymentComponent,
                    //     data: {
                    //       breadcrumb: 'Make a Payment',
                    //     },
                    // },
                    {
                        path: 'digitalwallet',
                        component: PaymentSetupComponent,
                        data: {
                          breadcrumb: 'Digital Wallet',
                        },
                    },
                ]
            },
            {
                path: 'backorders',
                component: BackOrdersComponent,
                children: [
                    {
                        path: 'orderitemdetail/:sku',
                        component: OrderItemDetailComponent
                    }
                ]
            },
            {
                path: 'shippedorders',
                component: ShippedOrdersComponent,
                data:{
                    breadcrumb: 'Recently Invoiced Orders',
                },
                children: [
                    {
                        path: 'orderitemdetail/:sku',
                        component: OrderItemDetailComponent,
                        data:{
                            breadcrumb: 'sku',
                        },
                        children: [
                            {
                                path: 'product/:sku',
                                component: ProductDetailComponent,
                                children: [
                                    {
                                        path: 'bundledproduct/:sku',
                                        component: ProductDetailComponent,
                                        data: {
                                            breadcrumb: 'sku',
                                        }
                                    }]
                            },
                            {
                                path: 'payment',
                                component: MakePaymentComponent,
                                data: {
                                  breadcrumb: 'Make a Payment',
                                },
                            }

                        ]
                    }
                ]
            },
            {
                path: 'searchorders',
                component: SearchOrdersComponent,
                data:{
                    breadcrumb: 'Search Orders',
                },
                children: [
                    {
                        path: 'orderitemdetail/:sku',
                        component: OrderItemDetailComponent,
                        data:{
                            breadcrumb: 'sku',
                        }
                    }
                ]
            },
            {
                path: 'searchorders/:searchparm',
                component: SearchOrdersComponent,
                data:{
                    breadcrumb: 'Search Orders',
                },
                children: [
                    {
                        path: 'orderitemdetail/:sku',
                        component: OrderItemDetailComponent,
                        data:{
                            breadcrumb: 'sku',
                        }
                    }
                ]
            }
        ]
    },
    {
        path: 'orders',
        redirectTo: '/myOrder/openorders',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MyOrderRoutingModule { }
